import moment from 'moment';
import { OrderConfirmationLocation } from '../OrderConfirmation';

export interface RefuelStatusLike {
  baseName: string;
  nickname: string;
  status: 'loading' | 'error' | 'warning' | 'success' | string;
  message?: string | null;
  caseNumber?: string | null;
  createdDate?: string | null;
}

const DEFAULT_STATUS_MESSAGE = 'Seu pedido está em análise';

export const toConfirmationLocations = (
  statusResponse: RefuelStatusLike[]
): OrderConfirmationLocation[] =>
  statusResponse.map((st) => {
    const isError = st.status === 'error';
    const isLoading = st.status === 'loading';

    return {
      id: st.baseName,
      title: st.nickname || st.baseName,
      createdAt:
        !isError && st.createdDate
          ? moment(st.createdDate).format('DD/MM/YYYY [às] HH:mm')
          : '',
      statusMessage:
        isError && st.message ? st.message : DEFAULT_STATUS_MESSAGE,
      protocol: isError ? '-' : st.caseNumber || 'Processando...',
      currentStep: 0,
      description: !isError && !isLoading && st.message ? st.message : '',
      isError,
    };
  });

export default toConfirmationLocations;
